(function (lib, img, cjs, ss, an) {

var p; // shortcut to reference prototypes
lib.ssMetadata = [];


// symbols:



(lib.CheckOutCookie_Title = function() {
	this.initialize(img.CheckOutCookie_Title);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1025,360);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.Title_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFCC").ss(1,1,1).p("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");
	this.shape.setTransform(-0.5,-0.8);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#0099FF").s().p("AIvEBQgngXgNgmQgMgnAAhPIACjfIACgUQAEgdATgaQASgbAjgQQAhgPAsAAQA7AAAnAYQAnAXAMAkQAMAkABBKQgBAVgTAPQgUAPgcAAQgcAAgUgOQgUgOAAgTIgChaIgCgHQgEgKgOAAQgRAAgEANQgEANAAAoIABEjIADAIQAEAMAQAAQAOAAAEgMQAFgNAAgsQAAgcAUgUQAUgUAcAAIAwADQATADABAFIgFBpIgHAXQgLAjgnAbQgnAag5AAQg7AAgmgWgAm2EJQghgOgUgdQgVgcgEggQgEggABhUIABi2IACgXQAEgiATgbQAUgcAhgPQAggPAsAAQAqAAAiAOQAhAOAUAcQAUAdAEAhQAEAeAABVIgBC3IgDAWQgEAhgTAcQgTAcghAPQghAPgtAAQgpAAghgOgAl7izQgFAJAAApIABEsIACAHQAEALANAAQAOAAAEgNQAEgOAAgtIgCkfIgCgHQgEgLgNAAQgKAAgGAJgEgjLAEBQgmgWgNgnQgMgnAAhPIABjfIADgUQAEgdATgaQASgbAigQQAhgPAtAAQA7AAAnAYQAmAXANAkQAMAkAABKQAAAVgUAPQgUAPgcAAQgcAAgTgOQgVgOAAgTIgBhaIgDgHQgDgKgPAAQgQAAgFANQgEANAAAoIACEjIACAIQAFAMAPAAQAPAAAEgMQAEgNAAgsQAAgcAVgUQAMgNAkgDIAvgBQAUADAAAFIgEBpIgHAXQgMAjgmAbQgnAag5AAQg7AAgngWgEAgxAEIQgggNgRgVQgSgWgGgZQgHgYAAgyQAAiAAFhEIAKgWQAOgiAjgRQAjgSAsAAQA3AAAkAVQAjAWAPAjQAOAkAAA/QAAAXgZARQgZARgiABQgjgBgZAPQgZANAAAUIACBQIADAGQAEAJANAAQAOAAAGgMQAFgMAAggQAAgYASgRQASgRAZAAIArAEQASAFAAAHIgCBAIgDAPQgGAWgRAZQgTAYgcANQgcAMgqAAQgpAAgggMgEAhmgBcQgEAIAAAlQAAANAGAKQAGAKAIAAQAIgBAGgEQAFgFAAgHIgBg1IgCgGQgEgKgLAAIgCgBQgMAAgDAJgATyEKQgegKgQgTQgSgVgGgbQgHgbAAg5QAAh4AEhAIAJgXQAMgjAigUQAhgVA0AAQArAAAgANQAfAOASAVQAQAWAGAXQAHAVAAAwIgCCvIgEATQgFAagTAZQgUAZgdALQgdALgnAAQgrAAgegKgAUrhcQgEAJAAAiIABDoIADAGQAEAKALAAQALAAAEgJQADgKAAgbIgBjvIgCgGQgEgIgLAAQgLAAgEAIgAOjEKQgegKgRgTQgRgVgGgbQgHgbAAg5QAAh4AEhAIAIgXQAOgjAhgUQAggVA1AAQArAAAgANQAgAOAQAVQARAWAGAXQAGAWABAvIgCCvIgEATQgFAagTAZQgUAZgdALQgdALgnAAQgrAAgegKgAPchcQgFAKAAAhIACDoIADAGQAEAKALAAQALAAAEgJQADgKAAgbIgBjvIgCgGQgEgIgLAAQgLAAgEAIgAh6EJQgSgKgKgSQgKgTgCgRQgCgRAAg7IAAhGQAAhcAThCQAThDAbABQAbgBATAsQATAsAAA+IABDLIACAGQADAKANAAQAPAAABgKQADgLAAg1IAAhGQAAhcAThCQAThDAbABQAbgBASBBQATBAABBaQgBBagTBAQgTBAgcABIgugFQgTgGABgHQAAgIgFACIgNAOIgOAHQgTALgaAAQgcAAgUgLgAzDEBQgfgTgOgjQgNgkAAhAQAAh+AEg/IAHgTQALgcAjgWQAkgXAzAAQAyAAAlAWQAkAXAMAhQALAiAAA+IhWgIQgkgHAAgLIgBg3IgDgGQgEgKgLABQgLgBgEAJQgEAHAAAeIABDqIAFAIQAFAMAMAAQANAAAEgNQAFgLAAgjQAAgWARgPQAQgQAYAAQAYAAARASQARASgBAaIgCASQgDAagTAbQgSAcgdAOQgfAOgqAAQg2AAghgTgA38EIQgggNgRgVQgRgUgHgbQgHgYAAgyQAAiFAFg/IAKgWQAPgiAjgRQAhgSAuAAQA2AAAkAVQAkAWAOAjQAOAiAABBQAAAXgZARQgZARgiABQgjgBgYAPQgZANAAAUIABBQIADAGQAEAJANAAQAOAAAGgMQAFgLAAghQAAgYASgRQASgRAZAAIArAEQASAFAAAHIgBBAIgEAPQgFAWgSAZQgSAYgdANQgcAMgqAAQgqAAgfgMgA3HhcQgDAIAAAlQAAAOAGAJQAFAKAIAAQAIgBAFgEQAGgFAAgHIgBg1IgCgGQgEgKgLAAIgBgBQgNAAgDAJgAdFDLQgUhAAAhaQAAhaAUhAQAUhBAbABQAcgBATBBQAUBAAABaQAABagUBAQgTBAgcABQgbgBgUhAgAauDvQgYgcgIgnQgIgngGAAQgFAAAAAnQgBAngSAcQgUAcgbABQgbgBgThCQgThCAAhdIAAhSQAAhdAThCQAThCAbAAQAbAAAUAhQASAgABAvQAAAuAFAOQAGAOAIgaQAJgbAVgSQAWgUAWABQAWgBAJAaQAIAagLAkQgLAjADBAQACBAAOA3QAOA2gIAnQgJAmgZABQgZgBgZgcgAD+EKIgNgCQgSgDgPgPQgOgNgEgSQgEgUAAhAQAAhbgEhBQgDhCgGABQgGgBgEgKQgEgKAAgOQAAgOAEgKQAEgLAGAAQAGAAADgKQAEgKAAgOQAAgOAUgKQATgLAbAAQAaAAATALQATAJAAAPQAAAOAGAKQAFAKAHAAQAHAAAFALQAFAKABAOQgBAOgFAKQgFAKgHABQgHAAgFAiQgGAiAAAwIACCjIADADQAEAFAgAAQAAAdgHAVQgIAUgLABgAr+DvQgYgcgIgnQgJgngFAAQgGAAAAAnQAAAngTAcQgUAcgbABQgbgBgShCQgThCAAhdIAAhSQAAhdAThCQAShCAbAAQAbAAAUAhQATAgAAAvQAAAuAGAOQAFAOAJgaQAIgbAWgSQAVgUAXABQAWgBAIAaQAIAagLAkQgLAjADBAQACBAAOA3QAOA2gIAnQgJAmgZABQgZgBgYgcgA7kDeQgTgtAAhAIgBjDIgCgIQgEgLgMABQgLAAgEALQgEAMAAAgIAABXQAABdgTBCQgTBCgbABQgbgBgThCQgThCAAhdIAAhSQAAhdAThCQAThCAbAAQAbAAATARQATASAAAZQAAAYAGAMQAHAMAJgIIANgFQATgIAWAAQAjAAAXASQAXARAGAYQAFAWAAA/IAABMQAABdgTBCQgTBCgbABQgbgBgTgtgAdFjOQgUgLAAgOQAAgOAUgKQAUgKAbAAQAcAAATAKQAUAKAAAOQAAAOgUALQgTAJgcABQgbgBgUgJg");
	this.shape_1.setTransform(-0.5,-0.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	// Layer 14
	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f().s("#003300").ss(5,1,1).p("AiQiIQgEBEAACAQAAAyAGAZQAHAZASAWQARAWAgALQAgANAoAAQAqAAAcgNQAcgMATgZQARgZAGgWIADgOIAChBQAAgGgSgFIgrgFQgZAAgSARQgSARAAAYQAAAggFANQgGALgPAAQgLAAgEgIIgDgGIgChQQAAgUAYgOQAZgOAjAAQAiAAAZgQQAZgRAAgYQAAg/gOglQgPgjgjgVQgjgWg3AAQgsAAgjASQgjARgOAigAASiFIABA2QAAAGgGAFQgFAFgIAAQgHAAgGgKQgGgJAAgNQAAgmAEgIQADgIAMAAQAMAAADAJg");
	this.shape_2.setTransform(217.1,5.7);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFCC").s().p("AhEDXQgggLgRgWQgSgWgHgZQgGgZAAgyQAAiAAEhEIALgWQAOgiAjgRQAjgRAsAAQA3AAAjAVQAjAVAPAjQAOAlAAA+QAAAZgZARQgZAQgiAAQgjAAgZAOQgYAOAAAUIACBQIADAGQAEAIALAAQAPAAAGgMQAFgMAAggQAAgYASgRQASgRAZAAIArAFQASAFAAAGIgCBBIgDAOQgGAWgRAZQgTAYgcANQgcAMgqAAQgoAAgggMgAgPiNQgEAIAAAlQAAAOAGAKQAGAJAHAAQAIAAAFgFQAGgFAAgGIgBg2IgDgHQgDgJgMAAQgMAAgDAIg");
	this.shape_3.setTransform(217.1,5.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_3},{t:this.shape_2}]}).wait(1));

	// Layer 13
	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f().s("#003300").ss(5,1,1).p("AAAkKQAbAAAUAKQAUAKAAAOQAAAPgUAKQgUAKgbAAQgaAAgUgKQgUgKAAgPQAAgOAUgKQAUgKAaAAgAAAirQAbAAAUBBQAUBAAABaQAABagUBBQgUBAgbAAQgaAAgUhAQgUhBAAhaQAAhaAUhAQAUhBAaAAg");
	this.shape_4.setTransform(191.3,0.9);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFFFCC").s().p("AguDKQgUhAAAhaQAAhZAUhBQAUhBAaAAQAbAAAUBBQAUBBAABZQAABagUBAQgUBBgbAAQgaAAgUhBgAgujPQgUgKAAgOQAAgOAUgLQAUgKAaAAQAbAAAUAKQAUALAAAOQAAAOgUAKQgUAKgbAAQgaAAgUgKg");
	this.shape_5.setTransform(191.3,0.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_5},{t:this.shape_4}]}).wait(1));

	// Layer 12
	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f().s("#003300").ss(5,1,1).p("AhEkKQAbAAATAhQATAhAAAuQAAAuAFAOQAGAOAIgaQAIgbAWgTQAWgTAWAAQAWAAAJAaQAIAagLAkQgLAjADBAQACBAAOA3QAOA3gIAmQgJAngZAAQgZAAgZgcQgYgcgIgnQgIgngGAAQgFAAAAAnQAAAogTAbQgTAcgbAAQgbAAgThCQgThCAAheIAAhSQAAhdAThBQAThDAbAAg");
	this.shape_6.setTransform(166.7,0.9);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#FFFFCC").s().p("AAwDvQgYgcgIgnQgIgngGgBQgFABAAAnQAAAogTAbQgTAcgbAAQgbAAgThCQgThDAAhdIAAhRQAAheAThCQAThCAbAAQAbAAATAhQATAhAAAuQAAAuAFAOQAGAPAIgbQAIgbAWgSQAWgUAWAAQAWAAAJAaQAIAagLAkQgLAjADBAQACBBAOA2QAOA2gIAnQgJAngZAAQgZAAgZgcg");
	this.shape_7.setTransform(166.7,0.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_7},{t:this.shape_6}]}).wait(1));

	// Layer 11
	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f().s("#003300").ss(5,1,1).p("AiQiAQgDBAAAB5QAAA5AGAbQAHAbARAUQAPATAfALQAeAKAqAAQAoAAAcgMQAdgLAUgZQATgYAGgbIAEgSIABivQAAgwgGgWQgGgXgRgVQgRgVgfgPQgggNgqAAQg0AAgiAVQghAWgMAhgAASiHIAADvQAAAcgDAKQgDAIgMAAQgKAAgEgJIgDgGIAAjpQAAgiADgIQAEgJAKAAQAMAAADAJg");
	this.shape_8.setTransform(134.3,5.7);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#FFFFCC").s().p("AhHDZQgfgKgPgTQgRgUgHgcQgHgbABg5QAAh4ADg/IAJgYQANgiAhgVQAigUA0AAQAqAAAgAMQAfAPARAVQARAWAGAWQAHAWAAAwIgDCuIgDATQgGAbgTAYQgUAZgcALQgdALgoAAQgpABgfgLgAgOiMQgDAIgBAjIABDoIADAFQAEAKAKAAQAMAAADgIQAEgKgBgcIgBjuIgCgGQgDgJgMAAQgKAAgEAJg");
	this.shape_9.setTransform(134.3,5.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_9},{t:this.shape_8}]}).wait(1));

	// Layer 10
	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f().s("#003300").ss(5,1,1).p("AAAiVQALAAAEAJIACAFIACDvQAAAcgEAKQgDAIgMAAQgKAAgEgJIgCgGIgCjpQAAghAEgJQAEgJAKAAgAiPiAQgEBAAAB5QAAA5AGAbQAHAbARAUQAQATAeALQAfAKApAAQAoAAAdgMQAdgLATgZQATgYAGgbIAEgSIABivQAAgvgGgXQgGgXgRgVQgQgVgggPQgggNgqAAQg0AAghAVQgiAVgNAig");
	this.shape_10.setTransform(100.7,5.7);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#FFFFCC").s().p("AhHDZQgegKgQgTQgRgUgHgcQgGgbAAg5QAAh4AEg/IAIgYQANgiAigVQAhgUA0AAQAqAAAgAMQAgAPAQAVQARAVAGAXQAGAXAAAvIgBCuIgEATQgGAbgTAYQgTAZgdALQgdALgoAAQgpABgfgLgAgOiMQgEAJAAAiIACDoIACAFQAEAKAKAAQAMAAADgIQAEgKAAgcIgCjuIgCgGQgEgJgLAAQgKAAgEAJg");
	this.shape_11.setTransform(100.7,5.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_11},{t:this.shape_10}]}).wait(1));

	// Layer 9
	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f().s("#003300").ss(5,1,1).p("AiDjdQASgaAjgQQAigPArAAQA6AAAnAYQAmAXANAkQAMAkAABKQAAAUgTAPQgVAPgcAAQgcAAgTgNQgUgOAAgTIgChaIgDgHQgDgKgPAAQgPAAgEAMQgFANAAAoIACEkIADAIQAEAMAOAAQAPAAAEgMQAFgNAAgsQAAgcAUgUQATgUAcAAIAxADQATAEAAAEIgEBpIgHAYQgMAigmAbQgnAag5AAQg6AAgngWQgmgWgNgoQgMgmAAhPIABjgIADgTQAEgdATgbg");
	this.shape_12.setTransform(65.9,0.9);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#FFFFCC").s().p("AhfEAQgmgVgNgoQgMgnAAhOIABjfIADgUQAEgdATgbQASgaAjgQQAigPArAAQA6AAAnAYQAmAXANAkQAMAjAABLQAAAUgTAPQgVAPgcAAQgcAAgTgNQgUgOAAgTIgChaIgDgHQgDgKgPAAQgPAAgEAMQgFANAAAoIACEkIADAIQAEALAOABQAPgBAEgLQAFgNAAgsQAAgcAUgUQATgUAcAAIAxADQATAEAAAEIgEBpIgHAXQgMAjgmAbQgnAag5AAQg6AAgngXg");
	this.shape_13.setTransform(65.9,0.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_13},{t:this.shape_12}]}).wait(1));

	// Layer 8
	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f().s("#003300").ss(5,1,1).p("AhHjVQAAgOATgKQATgLAbAAQAaAAATALQATAKAAAOQAAAPAFAJQAFAKAIAAQAHAAAFALQAFAKAAAOQAAAPgFAKQgFAJgHAAQgIAAgFAjQgFAjAAAvIACCjIADADIAkAFQAAAdgIAVQgHAVgLAAIhMgBIgNgDQgTgEgOgNQgOgOgEgSQgEgUAAg/QAAhcgEhBQgEhCgFAAQgGAAgEgJQgEgKAAgPQAAgOAEgKQAEgLAGAAQAFAAAEgKQAEgKAAgOg");
	this.shape_14.setTransform(26.3,2.7);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f("#FFFFCC").s().p("AgDD4IgNgDQgTgEgOgNQgOgOgEgSQgEgUAAg/QAAhcgEhBQgEhCgFAAQgGAAgEgJQgEgKAAgPQAAgOAEgKQAEgLAGAAQAFAAAEgKQAEgKAAgOQAAgOATgKQATgLAbAAQAaAAATALQATAKAAAOQAAAPAFAJQAFAKAIAAQAHAAAFALQAFAKAAAOQAAAPgFAKQgFAJgHAAQgIAAgFAjQgFAjAAAvIACCjIADADIAkAFQAAAdgIAVQgHAVgLAAg");
	this.shape_15.setTransform(26.3,2.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_15},{t:this.shape_14}]}).wait(1));

	// Layer 7
	this.shape_16 = new cjs.Shape();
	this.shape_16.graphics.f().s("#003300").ss(5,1,1).p("ABVjfQAaAAATBBQATBAAABbQAABagTBAQgUBAgbAAIgvgFQgTgFABgIQAAgHgFACQgGACgHALIgNAHQgTAMgaAAQgdAAgUgLQgTgKgJgSQgJgUgCgRQgCgRAAg6IAAhHQAAhcAThCQAShDAbAAQAbAAATAsQAUAtAAA9IABDMIACAGQACAJANAAQAOAAACgKIADiGQAAhcAThCQAThDAcAAg");
	this.shape_16.setTransform(-1,6.1);

	this.shape_17 = new cjs.Shape();
	this.shape_17.graphics.f("#FFFFCC").s().p("AhqDVQgUgLgIgRQgKgTgCgSQgCgRAAg7IAAhGQAAhcAThCQAShDAbAAQAbAAAUAsQATAtAAA9IABDMIACAFQACAKANAAQAPAAACgKIACiGQAAhcAThCQAUhDAaAAQAbAAATBBQATBBAABaQAABZgTBAQgUBBgbAAIgugFQgUgGABgHQAAgIgFADQgGACgHALIgNAHQgTALgaAAQgdABgTgLg");
	this.shape_17.setTransform(-1,6.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_17},{t:this.shape_16}]}).wait(1));

	// Layer 6
	this.shape_18 = new cjs.Shape();
	this.shape_18.graphics.f().s("#003300").ss(5,1,1).p("AiaiJIgBC3QAABVADAfQAEAgAVAdQAUAbAhAPQAiAOAoAAQAsAAAhgPQAhgPAUgbQATgdADghIADgWIABi3QAAhVgEgfQgDgggVgdQgUgcghgOQgigOgpAAQgrAAghAOQgiAQgTAbQgSAbgFAjgAgOizQAFgJAKAAQAMAAAEAKIACAHIACEfQAAAtgEAPQgDANgOAAQgMAAgEgLIgDgIIgBksQAAgpAGgIg");
	this.shape_18.setTransform(-35.9,0.9);

	this.shape_19 = new cjs.Shape();
	this.shape_19.graphics.f("#FFFFCC").s().p("AhKEIQghgOgUgbQgVgdgEggQgDgfAAhVIABi2IACgXQAFgjASgbQATgbAigPQAhgPArAAQApAAAiAOQAhAOAUAcQAVAdADAgQAEAfAABVIgBC2IgDAXQgDAggTAeQgUAbghAPQghAPgsAAQgoAAgigPgAgOizQgGAIAAApIABEtIADAHQAEALAMAAQAOAAADgNQAEgPAAgtIgCkeIgCgIQgEgKgMAAQgKAAgFAJg");
	this.shape_19.setTransform(-35.9,0.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_19},{t:this.shape_18}]}).wait(1));

	// Layer 5
	this.shape_20 = new cjs.Shape();
	this.shape_20.graphics.f().s("#003300").ss(5,1,1).p("AhyjHQAThDAbAAQAbAAATAhQATAhAAAuQAAAuAFAOQAGAOAIgaQAIgbAWgTQAWgTAWAAQAWAAAIAaQAJAagLAkQgLAjACBAQACBAAOA3QAOA3gIAmQgIAngaAAQgZAAgYgcQgYgcgIgnQgIgngGAAQgFAAAAAnQAAAngTAcQgTAcgbAAQgbAAgThCQgThCAAheIAAhSQAAhdAThBg");
	this.shape_20.setTransform(-81,0.9);

	this.shape_21 = new cjs.Shape();
	this.shape_21.graphics.f("#FFFFCC").s().p("AAwDvQgYgcgIgnQgIgngGgBQgFABAAAnQAAAngTAcQgTAcgbAAQgbAAgThCQgThCAAheIAAhRQAAheAThCQAThCAbAAQAbAAATAhQATAhAAAuQAAAuAFAOQAGAPAIgbQAIgbAWgSQAWgUAWAAQAWAAAIAaQAJAagLAkQgLAjACBAQACBBAOA2QAOA2gIAnQgIAngaAAQgZAAgYgcg");
	this.shape_21.setTransform(-81,0.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_21},{t:this.shape_20}]}).wait(1));

	// Layer 4
	this.shape_22 = new cjs.Shape();
	this.shape_22.graphics.f().s("#003300").ss(5,1,1).p("AhXjMQAkgXAzAAQAxAAAlAXQAkAWALAhQAMAjAAA9IhWgHQgkgIAAgLIgCg3IgCgGQgEgJgMAAQgKAAgEAIQgDAIAAAdIABDrIAEAHQAGAMAKAAQANAAAFgMQAFgMAAgiQAAgWARgQQAQgPAYAAQAZAAAQASQARASgBAaIgCARQgEAagSAcQgSAcgdAOQgdAOgsAAQg2AAgggUQgggTgNgjQgNgkAAg/QAAh/ADg/IAIgTQAKgcAkgWg");
	this.shape_22.setTransform(-112.8,5.7);

	this.shape_23 = new cjs.Shape();
	this.shape_23.graphics.f("#FFFFCC").s().p("AhWDQQgggTgNgjQgNgkAAg/QAAh/ADg/IAIgSQAKgdAkgXQAkgWAzABQAxgBAlAWQAkAXALAhQAMAiAAA+IhWgIQgkgHAAgLIgCg2IgCgHQgEgJgMAAQgKAAgEAIQgDAIAAAdIABDqIAEAIQAGAMAKAAQANAAAFgNQAFgLAAgjQAAgVARgQQAQgPAYAAQAZAAAQASQARASgBAaIgCARQgEAagSAcQgSAcgdAOQgdAOgsgBQg2ABgggUg");
	this.shape_23.setTransform(-112.8,5.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_23},{t:this.shape_22}]}).wait(1));

	// Layer 3
	this.shape_24 = new cjs.Shape();
	this.shape_24.graphics.f().s("#003300").ss(5,1,1).p("AiPiIQgFA/AACFQAAAyAGAZQAIAaARAVQASAWAfALQAfANAoAAQArAAAcgNQAdgMASgZQATgZAEgWIAEgOIABhBQAAgGgSgFIgrgFQgZAAgSARQgSARAAAYQAAAigFALQgFALgPAAQgMAAgEgIIgDgGIgBhQQAAgUAYgOQAYgOAjAAQAjAAAZgQQAYgRAAgYQAAhBgOgjQgOgjgkgVQgjgWg2AAQgtAAgiASQgiARgQAigAASiFIABA2QAAAGgGAFQgFAFgIAAQgHAAgFgKQgGgJAAgNQAAgmADgIQADgIANAAQALAAAEAJg");
	this.shape_24.setTransform(-145.9,5.7);

	this.shape_25 = new cjs.Shape();
	this.shape_25.graphics.f("#FFFFCC").s().p("AhEDXQgfgLgSgWQgRgVgHgaQgHgZAAgyQAAiEAFhAIAKgWQAPgiAigRQAjgRAtAAQA2AAAjAVQAjAVAOAjQAPAjAABAQAAAZgZARQgZAQgiAAQgjAAgZAOQgXAOAAAUIABBQIADAGQAEAIAMAAQAPAAAFgMQAFgLAAghQAAgYASgRQARgRAaAAIArAFQASAFAAAGIgBBBIgEAOQgEAWgTAZQgSAYgdANQgcAMgqAAQgpAAgfgMgAgPiNQgDAIAAAlQAAAOAGAKQAEAJAIAAQAIAAAGgFQAFgFAAgGIgBg2IgDgHQgDgJgLAAQgNAAgDAIg");
	this.shape_25.setTransform(-145.9,5.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_25},{t:this.shape_24}]}).wait(1));

	// Layer 2
	this.shape_26 = new cjs.Shape();
	this.shape_26.graphics.f().s("#003300").ss(5,1,1).p("AiBjHQAThDAbAAQAbAAATARQATASAAAYQAAAZAHANQAGALAJgIIANgFQATgIAWAAQAiAAAXASQAXARAGAYQAFAWAAA/IAABMQAABegTBCQgTBCgbAAQgaAAgUgtQgTguAAg/IgBjEIgCgHQgEgLgMAAQgKAAgEALQgEAMAAAgIAABXQAABegTBCQgTBCgbAAQgbAAgThCQgThCAAheIAAhSQAAhdAThBg");
	this.shape_26.setTransform(-179.8,0.9);

	this.shape_27 = new cjs.Shape();
	this.shape_27.graphics.f("#FFFFCC").s().p("AAmDdQgTgtAAhAIgBjDIgCgHQgEgLgMAAQgKAAgEALQgEAMAAAgIAABXQAABegTBCQgTBCgbAAQgbAAgThCQgThDAAhdIAAhRQAAheAThCQAThCAbAAQAbAAATASQATASAAAXQAAAZAHANQAGALAJgIIANgFQATgHAWAAQAiAAAXARQAXARAGAYQAFAWAABAIAABLQAABegTBCQgTBCgbAAQgaAAgUgug");
	this.shape_27.setTransform(-179.8,0.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_27},{t:this.shape_26}]}).wait(1));

	// Layer 1
	this.shape_28 = new cjs.Shape();
	this.shape_28.graphics.f().s("#003300").ss(5,1,1).p("AiDjdQASgaAjgQQAigPArAAQA6AAAnAYQAnAXAMAkQAMAkAABKQAAAUgTAPQgUAPgcAAQgcAAgUgNQgUgOAAgTIgChaIgCgHQgEgKgPAAQgPAAgEAMQgEANAAAoIABEkIADAIQAEAMAOAAQAPAAAFgMQAEgNAAgsQAAgcAUgUQAUgUAcAAIAwADQATAEAAAEIgEBpIgHAYQgLAignAbQgnAag5AAQg6AAgmgWQgmgWgOgoQgMgmAAhPIABjgIADgTQAEgdATgbg");
	this.shape_28.setTransform(-215.1,0.9);

	this.shape_29 = new cjs.Shape();
	this.shape_29.graphics.f("#FFFFCC").s().p("AheEAQgmgUgOgpQgMgnAAhOIABjfIADgUQAEgdATgbQASgaAjgQQAigPArAAQA6AAAnAYQAnAXAMAkQAMAjAABLQAAAUgTAPQgUAPgcAAQgcAAgUgNQgUgOAAgTIgChaIgCgHQgEgKgPAAQgPAAgEAMQgEANAAAoIABEkIADAIQAEALAOABQAPgBAFgLQAEgNAAgsQAAgcAUgUQAUgUAcAAIAwADQATAEAAAEIgEBpIgHAXQgLAjgnAbQgnAag5AAQg6AAgmgXg");
	this.shape_29.setTransform(-215.1,0.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_29},{t:this.shape_28}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-233.5,-29.7,468.1,61);


(lib.Text = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.CheckOutCookie_Title();
	this.instance.parent = this;
	this.instance.setTransform(0,0,0.75,0.75);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Text, new cjs.Rectangle(0,0,768.8,270), null);


(lib.shape31Hit = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#000000").s().p("AnODFIA4nRINlBTIgWHGg");
	this.shape.setTransform(-4.1,1.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-50.4,-25.6,92.7,53.9);


(lib.shape30OverDown = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#000000").ss(1,1,1).p("AAxhDIA/BGIALAMIArAwIAIAJAgDhIQguAcgvAcIgSAKIgyAeIgJAI");
	this.shape.setTransform(-3.4,-20.9);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFCC").s().p("AnDC6IAym3IEnAaIgzAfIgGgCIgLADIgEAJQgBAGAEAFQADAEAHAAQAFABAFgEQAEgEABgFQAAgGgEgFIgDgCIAzgfIDtAWIAqAwIgqgwIFBAeIgWGtgACtidQgEADAAAGQgBAGAEAEQADAFAHAAIAKgDQAEgEABgGIgEgKQgDgEgGgBIgCAAQgFAAgEAEgACDjNg");
	this.shape_1.setTransform(-4.2,1.2);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#336666").s().p("AnKCXIAEgbINoBGIAVmkIAUADIgSHCg");
	this.shape_2.setTransform(-1.8,8.8);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#000000").s().p("AmvDHIgfgCIA4nRIE+AeIDPAUIALANIgLgNIFYAhIgBAiIgVGkgAnDC6INxBEIAVmuIlBgdIjtgWIATgLIgTALIkngbgACriKQgDgFAAgFQAAgGAFgEIAIAKIgIgKQAEgEAGABQAGAAAEAFIADAKQAAAGgFAEIgKADQgGgBgEgEgAimirQgGgBgEgEQgDgEAAgGIAFgKIAKgDIAHACIgJAIIAJgIIADADQADAEAAAGQAAAGgFAEQgEADgEAAIgCAAgAB3jag");
	this.shape_3.setTransform(-4.1,1.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-50.4,-29.1,94.6,60.7);


(lib.shape29Up = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 4
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FF6600").s().p("AghBsQgDgEAAgFQAAgOAbhCIgyhpQgDgFgBgFQAAgGAEgEQAFgEAEAAQAGAAADAEQAVAiAXA8IAmhbQADgHAHgBQAEABAFAEQADADAAAGIgBAHIhCClIgIAaQgEALgIgBQgEAAgFgDg");
	this.shape.setTransform(15.8,3.9);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Layer 3
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FF6600").s().p("AAoBGIgJgKIgVALIgOAEQgdAAgNgSQgMgSAAgjQgBgfAVgZQAUgYAcABQAMgBAMAHQARAHAAALIgCAHIgCARIgBAeQgBAOADANIALAiIgDAJIgIAEgAgVgiQgNASAAAVQAAAXAHALQAHALAPABQAKAAAJgGIAMgKIgEg2IADgcIgIgDIgFgBQgSAAgPARg");
	this.shape_1.setTransform(3.2,0.4);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

	// Layer 2
	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FF6600").s().p("AgNBjIAEjGQAAgNALAAQAMAAAAANIgEDHQAAANgLABQgMgBAAgOg");
	this.shape_2.setTransform(-6.8,-3.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(1));

	// Layer 1
	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FF6600").s().p("Ag0BqIgDgJIAGjBQADgMAKACIALgCIASgBQAVAAAUARQAWAUAAAaQAAAjgXATQgVASgcAAIgPgCIgBBJQAAAGgDADQgEAEgEAAgAgbhSIgDBQIAOACQATAAAPgLQAPgNAAgWQAAgPgPgMQgOgKgOAAg");
	this.shape_3.setTransform(-16.7,-3.6);

	this.timeline.addTween(cjs.Tween.get(this.shape_3).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-22.2,-15,44.4,30.1);


(lib.shape28Up = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#000000").ss(1,1,1).p("AAnhAIBFBAIAMANIAuArIAJAJAgNhAIhYA+IgRALIgwAiIgIAK");
	this.shape.setTransform(-2.6,-21.4);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFF99").s().p("AmrjdIEoAEIgwAiIgHgCQgGAAgEAEQgEAEAAAGQAAAGAEAEQAEAEAGAAQAGAAAEgEQAEgEAAgGQAAgGgEgEIgDgCIAwgiIDuACIAuAsIgugsIFCAEIANGuItzADgACZirIAAAAQgEAEAAAGQAAAGAEAEQAEAEAGAAQAGAAAEgEQAEgEAAgGQAAgGgEgEQgEgEgGAAQgGAAgEAEgABrjXg");
	this.shape_1.setTransform(-1.4,1.4);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#336666").s().p("AnDDeIADgbINqAAIgMmkIAVABIARHCg");
	this.shape_2.setTransform(1.5,5.3);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#000000").s().p("AmlDrIgfAAIATnVIE/AGIDQADIANAMIgNgMIFaAGIABAhIAMGlgAm6DfINzgDIgMmuIlCgDIjvgDIASgMIgSAMIkogDgACYiWQgDgEAAgGQAAgGADgDIAJAIIgJgIIAAgBQAFgEAFAAQAHAAADAEQAFAEAAAGQAAAGgFAEQgDAEgHAAQgFAAgFgEgAjFigQgDgEAAgGQAAgGADgEQAEgEAGAAIAHACIgIAJIAIgJIADACQAFAEAAAGQAAAGgFAEQgDAEgHAAQgGAAgEgEgACYipgABejhg");
	this.shape_3.setTransform(-1.3,1.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-46.6,-28.9,93.3,56.8);


(lib.shape6UpOverDownHit = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#000000").ss(2,1,1).p("ADsg0QgDAYgfAHIhYBlQhCgggNArIgFADQglgOgnBTIi6gdIgFhIICTiiQgIgeAkgNQCrguB7BBQAJAYgFAwg");
	this.shape.setTransform(-0.1,3.1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFCC66").s().p("AhNAdQAZhCA1ASQAKgqA7AUIAHAPQAFAGgBADQhDgcgLAsQgqgNgjBPQgGgGADgegAhQAVQABgHAAgNIACgMQAYguAuAPQAHghBAAPIACAJIAEAIQgOgGgVgCQgWgBgPAaQg2gLgUA6g");
	this.shape_1.setTransform(2.7,12.2);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFF99").s().p("AjbBbICPibQgJgMAHgKQCLgsB7AiQAkAOgBAVQgEAcgqgDIhQBgIgmgEQgYAAgNAWQgcgIgRANQgRANgGAQg");
	this.shape_2.setTransform(-0.3,-0.4);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FF9933").s().p("AjhCAIgFghICyAWQgCAXAEAQgAjkBZIgCgaICwASIABAQIABgFQAAAMgCAIgABqA8QgCgHgEgEIBZhfQAlgHAFgOQgBAggfAEIhYBrQAAgLgFgFgABfAnQAAgHgDgEIBNhbQA5gHgHgmIgBgJIgDAVQABgVgkgOQh8giiKAsQALgPAvgHQCSgfBhA3QAFAHADAXQABAggrADIhWBmg");
	this.shape_3.setTransform(0.1,3.1);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#000000").s().p("AjoCGIgFhIICTiiQgIgeAkgNQCrguB7BBQAJAYgFAwQgDAYgfAHIhYBlQhCgggNArIgFADQglgOgnBTgAgxB4QgDAeAGAGQAjhQAqANQALgsBDAcQABgDgFgGIgHgPQg7gUgKAqQgMgEgKAAQgkAAgUA1gAjfCAICuAcQgEgPACgXIixgWgAjiBZICuAXIAEAAQAUg7A1ALQAQgaAWABQAVACAOAGIgEgIIgCgJQhBgPgHAhQgtgPgYAuIgCANIAAAGIgBgRIixgRgAgXiPQguAIgLAPQgHAJAIANIiOCaICpAWQAGgQARgNQARgNAcAHQAMgWAYAAIAmAFIBQhhQAqADAFgbIACgVIACAJQAGAlg4AIIhOBbQAEADAAAHIADAJIBXhlQArgDgBggQgDgXgGgIQg+gjhSAAQgvAAg0ALgAC/guIhZBgQAEADACAHQAEAFABALIBXhqQAggFABgfQgGAOgkAGg");
	this.shape_4.setTransform(-0.1,3.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-24.8,-14.2,49.6,34.7);


(lib.shape5 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#000000").ss(0.8,1,1).p("AAgAaIgDACQgMALABgLQACgXgSgLIggga");
	this.shape.setTransform(-18.7,6.3);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("#000000").ss(1,1,1).p("AgjhXIgDABQgPAIAAALQAAAHgaAZQAcgMgIAmQABBzA9gmQAYAeAhgOQAWgJgEAEIgGAIABOBPIABAAIACgC");
	this.shape_1.setTransform(8.5,-0.8);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f().s("#000000").ss(1,1,1).p("AgJADQARgHACAD");
	this.shape_2.setTransform(3.8,-9.4);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f().s("#000000").ss(2,1,1).p("ADJApQgsgeAYgyQACgdgegYQhDA0gFhSIgRAEIgiAEAhPBMQAHAIABAMIAAAAQgBALgHAJIgBACIABADIACACQAyAZA6AIIAFAAIADAAIABgBIADgBICVhnQAFgDAEgCAjIAOIAIg9IgBAAIgDhUIABgCIADgCIACgBIADgBIB0gLIAHgBIAEABIACAEQABAGAFAGQAIAGAKAAQAKAAAHgGIABAAQAGgHABgJIAAgCIABgDIADgCIAHAJIAZAdIADADIAEAEAAah0IAEAC");
	this.shape_3.setTransform(-3.5,2.8);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFCC00").s().p("ABxCGQg1gIgugVQAGgJAAgMIAAAAQAAgQgKgLIgBAAQgKgLgPAAQgOAAgKAJIADgFIgCACQAOgkhXghIAMgtIgBgCIgChFQAjAXAvAVIAPAHIABABQA+AUAnACIAGBIQgGAAgGAEQgIAFAAASQgBASAJAKQAGAIANADIgBACIAFA1gAhThZQgKAMAAAQQAAARAKAMQALALAPAAQAPAAAKgLQALgMAAgRQAAgQgLgMQgKgMgPABIgBAAQgPAAgKALg");
	this.shape_4.setTransform(-11.8,3.9);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FF9933").s().p("AgBAgIgEgBIgBAAQgNgDgGgIQgIgIAAgPQAAgRAIgFIAKgDIACACIADABIAEgCIABgCIAAAAIAIgCQAGgCALAGQALAFACAQQACAOgJAJIgSAMIgIADg");
	this.shape_5.setTransform(0.1,8.4);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#993300").s().p("ABXBaIgBgDIAAAAIAKgDIARgMQAKgJgCgPQgCgQgLgFQgLgGgHACIgIACIgBAAIAAgCIAAgBIABAAIAKgCQAGgCANAGQAMAGACASQACARgKAKIgVANIgJADgAA7BOQgJgJABgSQAAgSAIgGQAGgEAGAAIAAABIABACIgKADQgIAFAAARQgBAQAIAIQAHAIAMADIgBACIgBACQgNgEgGgIgAhygWQgKgMAAgQQAAgRAKgLQALgMAPAAQAPAAAKAMQALALAAARQAAAQgLAMQgKAMgPAAQgPAAgLgMgAhwhNQgJALAAAOQAAAOAJALQAJAKANAAQANAAAKgKQAJgLAAgOQAAgOgJgLQgKgKgNAAQgNAAgJAKg");
	this.shape_6.setTransform(-8.7,2.9);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#FFCC33").s().p("AhAAvIAIgDIAVgNQAKgKgBgRQgCgRgNgGQgNgGgGACIgKACIAAAAIgIhMIAlAHQACBzA8glQAYAdAigOIiLBfg");
	this.shape_7.setTransform(6.6,7.3);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#000000").s().p("AAeCbQg5gHgygZIgDgCIAAgDIABgCQAIgJAAgLIAAAAQgBgMgHgIQgIgHgJgBIgCAAQgKAAgHAGIgNgDIAGgEQAKgJAOAAQAPAAALALIAAAAQALALAAAQIAAAAQgBAMgFAJQAuAVAzAHIABAAIgFg1IAAgBIABgCIACgBIABgBIAFACIABACIAAABIAFA0ICLhgQAVgJgDAFIgGAIIAGgIIAAgBIACgBIAAAEIgIAGIiVBmIgEABIAAAAIgDABgAh1BMIABgBIgBABgAiHBIQgCgKAEAKgAiFA/QACgXgSgMIghgaQgDAKgJACIgFAAIAHg9IgBAAIgDhUIABgCIADgCIACAAIADgCIB0gLIAHgBIADACIACADQACAGAFAGQAHAGAKAAQALAAAHgGIAAAAQAHgHABgJIAAgCIABgDIADgCIAHAKIgCAAQgBALgJAJIAAAAQgKAKgPgBQgOABgKgKQgGgFgCgIIgDAAIAAAAIhsALQAiAUAtAVIAPAHQA9ATAlADIABgDIACgBIAWgKQAdgLgIAlIglgHIAHBMIAAABIAAABIgBACIgDACIgEgBIgCgCIAAgBIAAgBIgGhIQgmgChAgVIAAAAIgQgHQgvgWgigWIACBEIABADIgNAtQBYAggPAlQgFAFgDAAQgDAAAAgGg");
	this.shape_8.setTransform(-3.5,2.8);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#FF9900").s().p("ABtBDQg9AngCh0QAJglgdAMQAagZABgIQgBgLAQgHQAEBSBDg1QAeAYgCAeQgYAxAsAfIgCABIAAABQADgFgVAJQgLAEgKAAQgUAAgRgUgAixAIQgJgJAAgOQAAgPAJgKQAKgKANAAQANAAAJAKQAJAKAAAPQAAAOgJAJQgJAKgNAAQgNAAgKgKg");
	this.shape_9.setTransform(-2.2,-0.8);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#FFFF33").s().p("AglAXIgPgHQgsgUgigVIBsgLIAAAAIACAAQADAIAGAGQAKAJANAAQAPAAAJgJIAAAAQAKgJABgMIADAAIAZAcQgCABgBAAQAAABgBAAQAAAAABAAQAAAAABAAIAEACIAEAEIgEgEIAjgEIARgEIgRAEQARgIACADIgCABQgQAHABALQgBAHgaAZIgXAKIgCABIgBACQglgCg9gTg");
	this.shape_10.setTransform(-8.3,-7.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_10},{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-24.6,-13.8,42.1,33.2);


(lib.shape4 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#000000").ss(2,1,1).p("AAgh4IALgDIAAAAQA6gRAWgzIABgDIgCgDIgDgBQhGgCgxBMIgBAEIABADIgGgBIABgCIAAgDIAAgDIAAAAIAAgLIAAgBQAAgdAKgUIABgBQANAEASgLIACgBIABgDIgCgGIAAAAQgFgMghgKIgDAAQgQAGgBAQQgKAgAAAWQAAASAFALIgGgCIgBAAQgmgKgeACIAIAKQgLAPgBALQgCAGgOALQgOALA6AhIgJAEIAKAlQgUAHgKAvQADBSAggLIgjAzQARgTAEADQATAKAOACIAbgEIAHgJIARADQAdACAPgIIACgbIAVgdQgBhUgTgPIAFggIAUgDQgIgpAVgMIAdgHIAGgJQgcgWgxgDIgBAAIgHACIAAAAIgDAAIgFABIAFgBgAA0gZQgegOgaADQgaADgXAUIgggSAhuC3IgEAFIgFAAIADADQA0AxAwgXQAkAYAogcIADgCIAAgBQAPgQAPgIIgQgJIgcACIgFgR");
	this.shape.setTransform(1.6,-0.9);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FF9933").s().p("AgbBmIgLhQIASgrIgMhQQAagDAeANIgGAiQATAOACBTIgVAeIgCAbQgMAGgSAAIgNgBg");
	this.shape_1.setTransform(4.4,5.7);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFCC66").s().p("AgUA6QggALgEhRQAKgvAUgHIgKgmIAhASQAVgTAagEIANBQIgSAsIALBQIgSgCIgIAIIgaAEQgOgCgTgJQgEgEgRAUg");
	this.shape_2.setTransform(-3.3,6.4);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FF0000").s().p("AhBAkIAIgEQg5ggAOgKQANgMADgFQAAgMALgOIA5AHQAZANAwgJIAAAAIAFgBQAlAXAFAHQgVAMAIAoIgTADQgfgOgaADQgaAEgWATg");
	this.shape_3.setTransform(-0.4,-7.7);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#CC0000").s().p("AgNCaIgDgBIgDAAQgqAWgtgoIgFgFIAFAAQAQgTAFADQATAJANADIAcgFIAHgIIASACQAcADAPgIIAFAQIAcgBIgUAZIgBAAQgUAPgSAAQgQAAgOgLgAApikIABAAQAtADAaAUIgdAHQgGgHglgXg");
	this.shape_4.setTransform(1.7,4.4);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#339900").s().p("AAwgdQgXArg4ANIAAAAIgRADQAqg5A2gCg");
	this.shape_5.setTransform(7.8,-16.7);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#663300").s().p("AgUAtQgEgJABgPIAAAAQAAgVAJgeIAAgBQABgKAJgEQAXAJAFAHIgZgBIgBAAIgCgBIgEAAIgCACIAAADIACAJQgLAUAAAeIAAAAIAAAMg");
	this.shape_6.setTransform(2,-18.1);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#000000").s().p("AgRDZQgxAXg0gxIgDgDIAFAAIAEgFIAFAEQAuAoAqgVIACgBIADACQAgAXAkgbIABAAIAUgaIAQAJQgPAIgOAQIgBABIgDACQgVAPgVAAQgQAAgRgLgAAqhwIgBABIgFABIAAAAQgvAJgagOIg5gHIgHgKQAdgCAmAKIABAAIAGACQgFgLAAgSQAAgWAKggQABgQAQgGIAEAAQAgAKAGAMIAAAAIABAGIgBADIgBABQgTALgNgEIgBABQgJAUgBAdIAAABIAAALIAAAAIAAADIAAADIgBACIAHABIgCgDIABgEQAxhMBGACIADABIACADIgBADQgVAzg6ARIgBAAIgLADIAAAAIgFABIAFgBIAEAAIgBAAIAHgCIACAAQAxADAbAWIgGAJQgZgVgtgDgAgLjMIgBABQgJAfAAAVIAAABQAAAOAEAKIAAAAIAAgMIAAAAQAAgeALgVIgCgJIAAgDIACgCIAEgBIACACIAAAAIAbABQgGgIgXgIQgJAEAAAJgAALh/IARgDIAAAAQA5gNAXgsQg3ACgqA6g");
	this.shape_7.setTransform(1.8,-0.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.7,-24.7,26.7,47.7);


(lib.Background = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#000000").ss(2,1,1).p("AATAAIgmAA");
	this.shape.setTransform(-11.2,268.2);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#66CC66").s().p("EgwDAIgIgKxHMBgbAARIAAQ+g");
	this.shape_1.setTransform(299.5,212.2);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#336600").s().p("EApZAE9MhSHgBtInXgCIgGoKMBgWAAXIAAJig");
	this.shape_2.setTransform(299.8,328.4);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#999999").s().p("EgrSAKIIkvADIgBhNMBgRAAHIAABxUguDgAegtegAQgEgwLgJzIgDgvIJMgTMBXRAAuIAAAsg");
	this.shape_3.setTransform(299.5,212.3);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#666666").s().p("EgwBAQWIgBhPIHYACMA3tABNgEgwIAF3IgBhtIAIgKIEvgDMBbgAAtIAABsgEgwOgP1IAAggMBgcAASIAAAfg");
	this.shape_4.setTransform(299.5,255.4);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#003333").s().p("APHROMg3tgBNInYgCIAAgfIHXACMBSHABsgEgwEAHVIAAgmMBgWAAfIAAAegEgrOAE1IkvADIAAgkIEvgDUAtdAAQAuDAAeIAAAjgEgv+ADHQgGgBgDgEIgEgKIAAgBQABgGADgEQADgFAGAAMBgQAAIIAAAegEgwJgOfIgIgDIAAgYQADgDAEAAMBgcAARIAAAegEgwKgPdIgIgFIAAgQIALAIMBgZAAYIAAAHgEgm+gQsIpMATIABgeIJLgWMBXQAArIAAAkg");
	this.shape_5.setTransform(299.1,249.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	// Layer 1
	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#339999").s().p("EgvWAZQMAAAgyeMBetAAAMAAAAyeg");
	this.shape_6.setTransform(301.1,160.6);

	this.timeline.addTween(cjs.Tween.get(this.shape_6).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-14.1,-1,622.3,361.1);


(lib.food = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{rollfood:0});

	// Layer 18
	this.instance = new lib.shape6UpOverDownHit("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(781.2,-7.7,1.55,1.55);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({x:1546.3},69).to({x:35.3},1).to({x:781.2},69).wait(1));

	// Layer 17
	this.instance_1 = new lib.shape6UpOverDownHit("synched",0);
	this.instance_1.parent = this;
	this.instance_1.setTransform(522.4,-12.3,1.55,1.55);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({x:1287.5},69).to({x:-223.5},1).to({x:522.4},69).wait(1));

	// Layer 16
	this.instance_2 = new lib.shape6UpOverDownHit("synched",0);
	this.instance_2.parent = this;
	this.instance_2.setTransform(266.7,-15.4,1.55,1.55);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({x:1031.7},69).to({x:-479.3},1).to({x:266.7},69).wait(1));

	// Layer 15
	this.instance_3 = new lib.shape5("synched",0);
	this.instance_3.parent = this;
	this.instance_3.setTransform(872.8,-8.1,1.55,1.55,0.7);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).to({x:1637.9},69).to({x:126.9},1).to({x:872.8},69).wait(1));

	// Layer 14
	this.instance_4 = new lib.shape4("synched",0);
	this.instance_4.parent = this;
	this.instance_4.setTransform(701.5,-10.1,1.55,1.55,0.7);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({x:1466.5},69).to({x:-44.5},1).to({x:701.5},69).wait(1));

	// Layer 13
	this.instance_5 = new lib.shape5("synched",0);
	this.instance_5.parent = this;
	this.instance_5.setTransform(615.7,-11.2,1.55,1.55,0.7);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).to({x:1380.7},69).to({x:-130.3},1).to({x:615.7},69).wait(1));

	// Layer 12
	this.instance_6 = new lib.shape4("synched",0);
	this.instance_6.parent = this;
	this.instance_6.setTransform(444.3,-13.3,1.55,1.55,0.7);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({x:1209.3},69).to({x:-301.7},1).to({x:444.3},69).wait(1));

	// Layer 11
	this.instance_7 = new lib.shape5("synched",0);
	this.instance_7.parent = this;
	this.instance_7.setTransform(358.7,-14.3,1.55,1.55,0.7);

	this.timeline.addTween(cjs.Tween.get(this.instance_7).to({x:1123.8},69).to({x:-387.2},1).to({x:358.7},69).wait(1));

	// Layer 10
	this.instance_8 = new lib.shape4("synched",0);
	this.instance_8.parent = this;
	this.instance_8.setTransform(187.1,-16.4,1.55,1.55,0.7);

	this.timeline.addTween(cjs.Tween.get(this.instance_8).to({x:952.2},69).to({x:-558.8},1).to({x:187.1},69).wait(1));

	// Layer 9
	this.instance_9 = new lib.shape6UpOverDownHit("synched",0);
	this.instance_9.parent = this;
	this.instance_9.setTransform(35.3,-7.7,1.55,1.55);

	this.timeline.addTween(cjs.Tween.get(this.instance_9).to({x:1546.3},139).wait(1));

	// Layer 8
	this.instance_10 = new lib.shape6UpOverDownHit("synched",0);
	this.instance_10.parent = this;
	this.instance_10.setTransform(-223.5,-12.3,1.55,1.55);

	this.timeline.addTween(cjs.Tween.get(this.instance_10).to({x:1287.5},139).wait(1));

	// Layer 7
	this.instance_11 = new lib.shape6UpOverDownHit("synched",0);
	this.instance_11.parent = this;
	this.instance_11.setTransform(-479.3,-15.4,1.55,1.55);

	this.timeline.addTween(cjs.Tween.get(this.instance_11).to({x:1031.7},139).wait(1));

	// Layer 6
	this.instance_12 = new lib.shape5("synched",0);
	this.instance_12.parent = this;
	this.instance_12.setTransform(126.9,-8.1,1.55,1.55,0.7);

	this.timeline.addTween(cjs.Tween.get(this.instance_12).to({x:1637.9},139).wait(1));

	// Layer 5
	this.instance_13 = new lib.shape4("synched",0);
	this.instance_13.parent = this;
	this.instance_13.setTransform(-44.5,-10.1,1.55,1.55,0.7);

	this.timeline.addTween(cjs.Tween.get(this.instance_13).to({x:1466.5},139).wait(1));

	// Layer 4
	this.instance_14 = new lib.shape5("synched",0);
	this.instance_14.parent = this;
	this.instance_14.setTransform(-130.3,-11.2,1.55,1.55,0.7);

	this.timeline.addTween(cjs.Tween.get(this.instance_14).to({x:1380.7},139).wait(1));

	// Layer 3
	this.instance_15 = new lib.shape4("synched",0);
	this.instance_15.parent = this;
	this.instance_15.setTransform(-301.7,-13.3,1.55,1.55,0.7);

	this.timeline.addTween(cjs.Tween.get(this.instance_15).to({x:1209.3},139).wait(1));

	// Layer 2
	this.instance_16 = new lib.shape5("synched",0);
	this.instance_16.parent = this;
	this.instance_16.setTransform(-387.2,-14.3,1.55,1.55,0.7);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).to({x:1123.8},139).wait(1));

	// Layer 1
	this.instance_17 = new lib.shape4("synched",0);
	this.instance_17.parent = this;
	this.instance_17.setTransform(-558.8,-16.4,1.55,1.55,0.7);

	this.timeline.addTween(cjs.Tween.get(this.instance_17).to({rotation:0.6,x:191.2},69).to({rotation:0.7,x:952.2},70).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-576.9,-54.7,1476.7,80.2);


(lib.PlayButton = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 5
	this.instance = new lib.shape29Up("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(-0.4,6.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({rotation:4.6,x:-2.9,y:6.5},0).wait(1).to({startPosition:0},0).to({_off:true},1).wait(1));

	// Layer 1
	this.instance_1 = new lib.shape28Up("synched",0);
	this.instance_1.parent = this;

	this.instance_2 = new lib.shape30OverDown("synched",0);
	this.instance_2.parent = this;

	this.instance_3 = new lib.shape31Hit("synched",0);
	this.instance_3.parent = this;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-46.6,-28.9,93.3,56.8);


// stage content:
(lib.Title = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Animated
	this.text = new lib.Text();
	this.text.parent = this;
	this.text.setTransform(644.4,202,1,1,0,0,0,384.4,135);

	this.timeline.addTween(cjs.Tween.get(this.text).wait(47));

	// Background
	this.food = new lib.food();
	this.food.parent = this;
	this.food.setTransform(11.6,483.5,1.712,2.034,0,0,0,161.2,-14.7);

	this.background = new lib.Background();
	this.background.parent = this;
	this.background.setTransform(654.1,431.3,2.174,2.143,0,0,0,297.2,179.8);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#339999").s().p("EhyOAFfIAAq8MDkdAAAIAAK8g");
	this.shape.setTransform(720.3,20);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.background},{t:this.food}]}).wait(47));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-592.9,375,2704.4,832.6);
// library properties:
lib.properties = {
	width: 1320,
	height: 780,
	fps: 24,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"../../../deploy/assets/images/CheckOutCookie_Title.png?1524247638406", id:"CheckOutCookie_Title"}
	],
	preloads: []
};




})(lib = lib||{}, images = images||{}, createjs = createjs||{}, ss = ss||{}, AdobeAn = AdobeAn||{});
var lib, images, createjs, ss, AdobeAn;